import { IReview } from "../types/reviews";

const REVIEWS_ENDPOINT_PREFIX = "reviews";

export async function handleResponse(): Promise<IReview[]> {
    const results = await fetch(`${process.env.REACT_APP_API_URL}${REVIEWS_ENDPOINT_PREFIX}`);
    return await results.json() as IReview[];
}
